import { FieldDisplayRenderWrapper } from "../components/FieldDisplayRenderWrapper.js";
import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import "react";
import { Icon, Label } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdDone } from "react-icons/md";
//#region src/modules/FormBuilder/components/Fields/Checkbox/Display.tsx
var CheckboxFieldDisplay = ({ config }) => {
	const { valuesByFieldId } = useFormBuilderFieldsContext();
	let value = valuesByFieldId[config.id];
	if (typeof value === "string") value = value.toLowerCase() === "true";
	if (value) return /* @__PURE__ */ jsx(FieldDisplayRenderWrapper, {
		config,
		children: /* @__PURE__ */ jsxs("div", { children: [
			/* @__PURE__ */ jsx(Icon, {
				Icon: MdDone,
				size: "sm"
			}),
			" ",
			/* @__PURE__ */ jsxs(Label, { children: [config.options.displayCheckedLabel, config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {})] })
		] })
	});
	if (!value && config.options.displayUncheckedLabel) return /* @__PURE__ */ jsx(FieldDisplayRenderWrapper, {
		config,
		children: /* @__PURE__ */ jsxs("div", { children: [
			/* @__PURE__ */ jsx(Icon, { Icon: IoClose }),
			" ",
			/* @__PURE__ */ jsxs(Label, { children: [config.options.displayUncheckedLabel, config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {})] })
		] })
	});
	return null;
};
//#endregion
export { CheckboxFieldDisplay };

//# sourceMappingURL=Display.js.map